import { type ReactNode, useLayoutEffect, useRef } from "react";

import { HaNContext, HaNSearchContext, type HereAndNowTab } from "@lib/logic";
import { useRequiredContext } from "@lib/utils";

import { HaNSearchResults } from "../../search/HaNSearchResults";
import { HaNErrorBoundary } from "../../shared/HaNErrorBoundary";

export const HaNList = ({ children }: { children: ReactNode }) => {
  const { tab } = useRequiredContext(HaNContext);
  const { isSearching } = useRequiredContext(HaNSearchContext);
  const listRef = useRef<HTMLDivElement>(null);
  const scrollTops = useRef(new Map<HereAndNowTab | "search", number>());
  const view = isSearching ? "search" : tab;

  useLayoutEffect(
    function restoreScrollOfView() {
      if (listRef.current) {
        listRef.current.scrollTop = scrollTops.current.get(view) ?? 0;
      }
    },
    [view],
  );

  return (
    <div
      ref={listRef}
      onScroll={event => scrollTops.current.set(view, event.currentTarget.scrollTop)}
      className="relative col-start-1 row-start-4 flex min-h-0 flex-col overflow-y-auto border-r bg-white max-sm:row-start-5 max-sm:border-r-0 max-sm:pb-20 max-sm:group-data-[map-list-view=map]/han:hidden">
      <HaNErrorBoundary area="List">{isSearching ? <HaNSearchResults /> : children}</HaNErrorBoundary>
    </div>
  );
};
